import {gpEventKey} from '../../analytics/constants'
import Analytics from '@app/analytics/client-analytics/event-analytics'

import GameplayerEventType from '../../analytics/event-type'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'

export interface HeartSelect {
  gameCode: string
  favorite: boolean
  categoryName: string
  layoutName?: string
  'search-game-favorited'?: boolean
}

interface GameCardInfo {
  gameCode: string
  categoryName: string
  layoutName?: string
}

function sendOnHomeBackButtonClicked() {
  triggerAnalytics(GameplayerEventType.HomeBackButtonClicked).sendAll()
}

function sendOnHoveringIconShowed() {
  triggerAnalytics(GameplayerEventType.HoveringIconShowed).sendAll()
}

function sendOnHoveringIconClicked() {
  triggerAnalytics(GameplayerEventType.HoveringIconClicked).sendAll()
}

function sendOnDominoBottomSheetOpened() {
  triggerAnalytics(GameplayerEventType.DominoBottomSheetOpened).sendAll()
}

function sendOnDominoGameCardClicked({gameCode, categoryName, layoutName}: GameCardInfo) {
  triggerAnalytics(GameplayerEventType.DominoGameCardClicked, {
    [gpEventKey.gameCode]: gameCode,
    [gpEventKey.category]: categoryName,
    [gpEventKey.layout]: layoutName || categoryName,
  })
}

function sendOnDominoGameFavorited(data: HeartSelect) {
  triggerAnalytics(GameplayerEventType.DominoGameFavorited, {
    [gpEventKey.gameCode]: data.gameCode,
    [gpEventKey.favorite]: data.favorite,
    [gpEventKey.category]: data.categoryName,
    [gpEventKey.layout]: data.layoutName,
  })
}

export default {
  sendOnHomeBackButtonClicked,
  sendOnHoveringIconShowed,
  sendOnHoveringIconClicked,
  sendOnDominoBottomSheetOpened,
  sendOnDominoGameCardClicked,
  sendOnDominoGameFavorited,
}
